import { DateTime } from 'luxon';
import taskService from 'resources/task/task.service';
import * as taskHelpers from 'resources/task/task.helpers';

export const getMilestoneOutdatedEmails = async (milestoneId) => {
  const openEmails = await taskService.getMilestoneOpenEmails(milestoneId);

  const outdatedEmails = taskHelpers
    .filterOpenTasksAndExtendWithDueDate(openEmails)
    .filter((task) => {
      if (!task.dueDate) {
        return false;
      }

      return task.dueDate.toMillis() <= DateTime.now().minus({ days: 1 }).toMillis();
    });

  return outdatedEmails;
};
